import { useCallback, useContext, useState } from "react";
import { FiX } from "react-icons/fi";

import { Modal } from "~/components/Modal";
import { UpdateAdminForm } from "~/forms/UpdateAdminForm";
import { updateManager } from "~/modules/admin/services";
import type { ListAdminsDTO } from "~/modules/admin/types";
import { authenticationAtom } from "~/modules/authentication/data";
import { updateSessionUser } from "~/modules/authentication/services";
import type { AdminUser } from "~/modules/authentication/types";
import { useAtom } from "~/observers/jotai";

import { managersContext } from "../context";

type Props = {
	data: ListAdminsDTO["admins"][number];
};

export const AdminCard: React.FC<Props> = ({ data }) => {
	const [session] = useAtom(authenticationAtom);
	const { handleResetList } = useContext(managersContext);
	const [visible, setVisible] = useState<boolean>(false);

	const handleCloseModal = useCallback(() => {
		setVisible(false);
	}, []);

	const handleOpenModal = useCallback(() => {
		setVisible(true);
	}, []);

	const handleSubmit = useCallback(
		async (payload: AdminUser) => {
			await updateManager(data.id, payload).then((res) => {
				if (res.id === session?.user.id) {
					updateSessionUser(res);
					handleResetList();
				}
				setVisible(false);
			});
		},
		[data.id, session?.user.id, handleResetList],
	);

	return (
		<>
			<button
				className="flex flex-col gap-2 p-2 text-start rounded-lg bg-white
          max-h-40 ring-1 ring-stone-200 shadow-md"
				onClick={handleOpenModal}
			>
				<h3 className="text-lg font-semibold">{data.name}</h3>
				<p className="line-clamp-1">{data.email}</p>
				<p className="py-1 px-2 text-center bg-slate-100 rounded-md">
					{data.role}
				</p>
				<p
					className="py-1 px-2 text-center rounded-md bg-gpa-blue-50/40
                    hover:bg-blue-100 text-gpa-blue-400 duration-150"
				>
					Detalhes
				</p>
			</button>

			<Modal visible={visible}>
				<div className="flex flex-col gap-4">
					<div className="flex items-center justify-between mb-4">
						<h1 className="text-xl">Atualizar Administrador</h1>
						<button
							type="button"
							className="p-2 rounded-full hover:bg-slate-50"
							onClick={handleCloseModal}
						>
							<FiX size={26} />
						</button>
					</div>

					<UpdateAdminForm onSubmit={handleSubmit} defaultValues={data} />
				</div>
			</Modal>
		</>
	);
};
